import theme from '../theme'
import { makeStyles } from '@material-ui/core'

const styleOverride = makeStyles({
  /* Styles applied to the root element. */
  root: {
    display: 'table',
    width: '100%',
    borderCollapse: 'collapse',
    borderSpacing: 0,
    '& caption': {
      ...theme.typography.body2,
      padding: theme.spacing(2),
      color: theme.palette.text.secondary,
      textAlign: 'left',
      captionSide: 'bottom',
    },
  },
  /* Styles applied to the root element if `stickyHeader={true}`. */
  stickyHeader: {
    borderCollapse: 'separate',
  },
})
export default styleOverride
